import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import type { IRoadsideAssistanceFeature, IRoadsideAssistanceFeatureDto } from "./IRoadsideAssistanceFeature";
import { Settings } from "@/globals";

export class RoadsideAssistanceFeature implements IRoadsideAssistanceFeature
{

    isEnabledInAppSettings: boolean;
    hasRoadsideAssistance: boolean;
    title: string;
    subTitle: string;
    provider: string;
    coverType: string;
    phoneNumber: string;
    linkUrl: string;
    durationInMonths: number;
    utcDateExpires?: string | Dayjs;
    battery?: string;
    tyres?: string;
    fuel?: string;
    lockout?: string;
    towing?: string;
    carHire?: string;
    accommodation?: string;
    ambulance?: string;
    general?: string;
    policyNumber: string;

    constructor( model: IRoadsideAssistanceFeatureDto )
    {
        this.isEnabledInAppSettings = model.isEnabledInAppSettings;
        this.hasRoadsideAssistance = model.hasRoadsideAssistance;
        this.title = model.title;
        this.subTitle = model.title;
        this.provider = model.provider;
        this.coverType = model.coverType;
        this.durationInMonths = model.durationInMonths;
        this.phoneNumber = model.phoneNumber;
        this.linkUrl = model.linkUrl;
        this.utcDateExpires = dayjs( model.utcDateExpires );
        this.battery = model.battery;
        this.tyres = model.tyres;
        this.fuel = model.fuel;
        this.lockout = model.lockout;
        this.towing = model.towing;
        this.carHire = model.carHire;
        this.accommodation = model.accommodation;
        this.ambulance = model.ambulance;
        this.general = model.general;
        this.policyNumber = ( model.policyNumber ?? '' ).trim().length > 0 
            ? model.policyNumber 
            : Settings.RoadsideAssistance.PolicyNumber;
    }

    /**
     * True if the feature is enabled
     */
    get isEnabled()
    {
        return this.hasRoadsideAssistance;
    }
    
}